(function () {
  if (window.__TreatmentsPageInit) return;
  window.__TreatmentsPageInit = true;

  const norm = (s) => (s || "").toLowerCase().trim().replace(/\s+/g, " ");

  function setCategoryActive(btns, activeValue) {
    btns.forEach((b) => {
      const isActive = (b.dataset.filterCategory || "all") === activeValue;
      b.classList.toggle("bg-[#474649]", isActive);
      b.classList.toggle("text-white", isActive);

      b.classList.toggle("bg-[#F5F5F5]", !isActive);
      b.classList.toggle("text-[#474649]", !isActive);
      b.classList.toggle("hover:bg-[#E8E8E8]", !isActive);
    });
  }

  function setDrugActive(btns, activeValue) {
    btns.forEach((b) => {
      const isActive = (b.dataset.filterDrug || "all") === activeValue;
      b.classList.toggle("bg-[#A890FE]", isActive);
      b.classList.toggle("text-white", isActive);

      b.classList.toggle("bg-[#F5F5F5]", !isActive);
      b.classList.toggle("text-[#474649]", !isActive);
      b.classList.toggle("hover:bg-[#E8E8E8]", !isActive);
    });
  }

  function init() {
    const searchEl =
      document.querySelector("[data-treatments-search]") ||
      document.querySelector('[data-testid="search-treatments"]');

    const groupsRoot = document.getElementById("treatmentsGroups");
    if (!groupsRoot) return;

    const resultsCountEl = document.querySelector('[data-testid="results-count"]');
    const noTreatmentsEl = document.getElementById("noTreatments");

    const categoryBtns = Array.from(document.querySelectorAll("button[data-filter-category]"));
    const drugBtns = Array.from(document.querySelectorAll("button[data-filter-drug]"));

    const filterToggleBtn = document.querySelector('[data-testid="filter-toggle"]');
    const filtersPanel = document.getElementById("filtersPanel");
    const filterChevron = document.querySelector("[data-filter-chevron]");

    const state = { q: "", category: "all", drug: "all" };

    function apply() {
      const q = norm(state.q);
      let totalVisible = 0;

      const groups = Array.from(groupsRoot.querySelectorAll("[data-treatment-group]"));

      groups.forEach((group) => {
        const groupCategory = (group.dataset.category || "").trim();
        const groupCategoryNorm = norm(groupCategory);

        const cards = Array.from(group.querySelectorAll("[data-treatment-card]"));
        let visibleInGroup = 0;

        cards.forEach((card) => {
          const cardDrug = (card.dataset.drug || "").trim();
          const cardDrugNorm = norm(cardDrug);

          const searchable = norm(card.dataset.search || card.textContent);

          const matchSearch = !q || searchable.includes(q);
          const matchCategory = state.category === "all" || groupCategoryNorm === norm(state.category);
          const matchDrug = state.drug === "all" || cardDrugNorm === norm(state.drug);

          const show = matchSearch && matchCategory && matchDrug;

          card.classList.toggle("hidden", !show);
          if (show) {
            visibleInGroup++;
            totalVisible++;
          }
        });

        const countEl = group.querySelector("[data-group-count]");
        if (countEl) countEl.textContent = `(${visibleInGroup})`;

        group.classList.toggle("hidden", visibleInGroup === 0);
      });

      if (resultsCountEl) {
        resultsCountEl.textContent = `Showing ${totalVisible} treatment${totalVisible === 1 ? "" : "s"}`;
      }
      if (noTreatmentsEl) {
        noTreatmentsEl.classList.toggle("hidden", totalVisible !== 0);
      }
    }

    // Search
    if (searchEl) {
      searchEl.addEventListener("input", (e) => {
        state.q = e.target.value || "";
        apply();
      });
    }

    // Category filter
    if (categoryBtns.length) {
      setCategoryActive(categoryBtns, "all");
      categoryBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          state.category = btn.dataset.filterCategory || "all";
          setCategoryActive(categoryBtns, state.category);
          apply();
        });
      });
    }

    // Drug filter
    if (drugBtns.length) {
      setDrugActive(drugBtns, "all");
      drugBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          state.drug = btn.dataset.filterDrug || "all";
          setDrugActive(drugBtns, state.drug);
          apply();
        });
      });
    }

    // Mobile toggle
    if (filterToggleBtn && filtersPanel) {
      filterToggleBtn.addEventListener("click", () => {
        filtersPanel.classList.toggle("hidden");
        if (filterChevron) filterChevron.classList.toggle("rotate-90");
      });
    }

    apply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Theme editor support (when sections reload)
  document.addEventListener("shopify:section:load", init);
})();